import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { forkJoin, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { constObj } from '../../Constants/constants';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';
import { LoginService } from '../../services/Login.service';
import { OpenLeftNavLinkService } from '../../services/open-left-nav-link.service';
import { SessionService } from '../../services/Session.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-inline-glossary',
  templateUrl: './inline-glossary.component.html',
  styleUrls: ['./inline-glossary.component.css']
})
export class InlineGlossaryComponent implements OnInit {
  glossaryTermId: string = "";
  glossaryTitle: string = "";
  glossaryTermUsage: string = "";
  glossaryBody: any = "";
  glossaryData: any = [];
  glossarytopic: any;
  seeTopics: string = "";
  event$;
  @Input() TermId: string = "";
  @Output() myEvent = new EventEmitter<string>();
  constructor(private commonDataService: CommonDataService, private graphQlService: GraphqlService, public loginService: LoginService, private session: SessionService,
    private openleftnavlink: OpenLeftNavLinkService, private domSanitizer: DomSanitizer, private route: Router, public dialog: MatDialog) {
  }

  secDefinition = constObj.secDefinition;
  isStarting: boolean;
  ngOnInit(): void {
    this.isStarting = false;
    this.getGlossaryData();

    this.event$
      = this.route.events
        .pipe(
          filter(event => event instanceof NavigationEnd)
        )
        .subscribe(() => {
          this.closeOverlay();

        })
  }

  ngOnChanges() {
    if (this.isStarting) {
      this.ngOnInit();
    }
  }

  getGlossaryData() {
    this.glossaryTermId = this.commonDataService.glossaryTermId.getValue();

    // this.commonDataService.glossaryTermId.subscribe(glossaryID=>{
    // this.glossaryTermId=glossaryID;
    this.commonDataService.showLoader.next(true)
    this.glossarytopic = [];
    this.distinctTopics = [];
    this.contacts = [];
    this.glossaryData = [];
    if (this.glossaryTermId != "" && this.glossaryTermId != null) {
      forkJoin([
        this.graphQlService.getInlineGlossaryContent(this.glossaryTermId),
        this.graphQlService.getGlobalLabels()
      ]).subscribe(([glossaryData, glossaryLabels]) => {
        this.isStarting = true;
        var labels = glossaryLabels.content.data.labels;

        this.mapGlossaryContent(glossaryData?.hits?.hitsList);
        //this.delay(3000);
        this.glossaryTermUsage = labels.filter(x => x.key == "glossary_termUsage").map(y => y.value);
        this.seeTopics = labels.filter(x => x.key == "glossary_see").map(y => y.value);
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
    }
    //}, err => {
    //  console.log(err);
    //  this.commonDataService.showLoader.next(false);
    //});

  }
  //delay(delayInms) {
  //  return new Promise(resolve => {
  //    setTimeout(() => {
  //      resolve(2);
  //    }, delayInms);
  //  });
  //}
  contacts: any = [];
  distinctTopics: any = [];
  mapGlossaryContent(data) {
    if (data) {
      data.forEach(res => {
        this.glossarytopic = [];
        this.distinctTopics = [];
        this.contacts = [];
        let source = res.source;
        this.glossaryTitle = source.title;
        if (source.body.includes("pending-text")) {
          source.body = this.addPendingContent(source.body);
        }
        this.glossaryBody = this.domSanitizer.bypassSecurityTrustHtml(source.body);
        if (source.usage != null) {
          source.usage.forEach(usage => {
            this.glossarytopic.push(usage)
          });
        }
        var count = 0;
        if (this.glossarytopic.length > 0) {
          this.glossarytopic.forEach(topicRes => {
            if (topicRes.topic != null && topicRes.topic != undefined) {
              if (count == 0) {
                let obj = {
                  topic: topicRes.topic,
                  topicData: [topicRes]
                }
                this.distinctTopics.push(obj);
                count++;
              }
              else {
                var topics = this.distinctTopics.filter(x => x.topic == topicRes.topic);
                if (topics.length > 0) {
                  this.distinctTopics.filter(x => x.topic == topicRes.topic)[0].topicData.push(topicRes);
                }
                else {
                  let obj = {
                    topic: topicRes.topic,
                    topicData: [topicRes]
                  }
                  this.distinctTopics.push(obj);
                }
                count++;
              }
            }
          })
        }
        this.distinctTopics = this.distinctTopics.sort((a, b) => (a.topic < b.topic) ? -1 : 1);
        this.glossaryData = { name: this.glossaryTitle, body: this.glossaryBody, topic: this.glossarytopic, seetopic: this.distinctTopics, type: source.glossaryType };
        this.contacts.push(this.glossaryData);
      })
      this.commonDataService.showLoader.next(false);
    }
  }

  addPendingContent(body) {
    if (body != null && body.includes("pending-text")) {
      var doc = new DOMParser().parseFromString(body, "text/html");
      let ImageDivs = doc.getElementsByClassName("pending-text") as HTMLCollectionOf<HTMLElement>;
      for (let i = 0; i < ImageDivs.length; i++) {
        let normText = doc.getElementsByClassName("norm-text") as HTMLCollectionOf<HTMLElement>;

        if (normText.length == 0) {
          ImageDivs[i].className += " mt-0";
        }
        let pending_content_text_div = doc.getElementsByClassName("pending-question-icon") as HTMLCollectionOf<HTMLElement>;
        if (pending_content_text_div != null && pending_content_text_div.length == 0) {
          let divBlock = document.createElement("div");
          divBlock.setAttribute("id", "pending-content-text")
          let img = document.createElement("img");
          img.src = "../../../../assets/icons/clock-black.svg";
          img.alt = "Clock Image";
          img.className = "pending-clock-icon"
          let imgQuestion = document.createElement("img");
          imgQuestion.src = "../../../../assets/icons/Help.svg";
          imgQuestion.alt = "Question Image";
          imgQuestion.className = "pending-question-icon";
          let textBlock = document.createElement("span");
          textBlock.innerText = "PENDING CONTENT";
          textBlock.className = "mat-Info";
          divBlock.appendChild(img);
          divBlock.appendChild(textBlock);
          divBlock.appendChild(imgQuestion);
          divBlock.className = "bottomMargin";
          ImageDivs[i].insertBefore(divBlock, ImageDivs[i].firstChild);
        }

        let dateSection = doc.getElementsByClassName("date-effective") as HTMLCollectionOf<HTMLElement>;

        if (dateSection.length > 0) {
          for (let j = 0; j < dateSection.length; j++) {
            let divBlock1 = document.createElement("div");
            divBlock1.className = "mt-1rem";
            dateSection[j].insertBefore(divBlock1, dateSection[j].firstChild);
            dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(P)", '<img src="../../../../assets/icons/P-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB P">');
            dateSection[j].innerHTML = dateSection[j].innerHTML.replace("(N)", '<img src="../../../../assets/icons/N-FASB.svg" class="close-nav-icon-right-overlay" alt="Pending FASB N">');

            let guidanceLink = dateSection[j].nextElementSibling;
            if (guidanceLink.tagName.toLowerCase() === 'a' && guidanceLink.className == "xref") {
              guidanceLink.insertAdjacentHTML('afterend', "<div></div>");
            }
          }
        }
      }
      body = doc.documentElement.innerHTML;
      return body;
    }
  }

  OpenLink(event) {
    const path: any = event.composedPath() as Array<any>;
    event.preventDefault();
    const xref = path.find(p => p.tagName && p.tagName.toLowerCase() === 'a' && p.className == "xref");
    var searchTerm = event.target.innerText;
    var dataLink = event.target.dataset.link;
    if (searchTerm.toLocaleLowerCase().includes(("accounting standards update").toLocaleLowerCase())) {
      this.graphQlService.getGASBLink().subscribe(data => {
        let FASBPath: string = "<a href='" + data + "' target='blank' class='dialog highlight-blue border-bottom-help cursor-pointer singleLine'>" + data + "</a>";
        this.commonDataService.CrossRefReportNotGenerated.next(false);
        this.commonDataService.isConfirmationPopUpOpen.next(true);
        this.dialog.open(ConfirmDialogComponent, {
          disableClose: true,
          width: '600px',
          data: constObj.notAvailableForBAsic + FASBPath
        });
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
    }
    else {
      if (xref && isNaN(Number(searchTerm.split("-")[0])) && !searchTerm.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase()) && !searchTerm.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {

        let href = xref.getAttribute('href').split("/");
        let guid = xref.getAttribute('href').includes('#') ? xref.getAttribute('href').split('#')[1] : href[href.length - 1];
        this.commonDataService.showLoader.next(true);
        let glossaryParentGuids = this.commonDataService.glossaryParentGuid.getValue();
        glossaryParentGuids.push(this.glossaryTermId)
        let title = localStorage.getItem("guids") != "" ? localStorage.getItem("guids") + " , " + this.glossaryTitle : this.glossaryTitle;
        localStorage.setItem("guids", title);
        this.commonDataService.glossaryParentGuid.next(glossaryParentGuids);
        this.commonDataService.glossaryTermId.next(guid);
        // this.getGlossaryData();
        this.commonDataService.childComponent.next(true);
      }
      else if (dataLink == "contentPage" || event.target.className.includes("ditamap")) {
        this.openleftnavlink.GetLeftNavLink(event);
        this.closeOverlay();
      }
      else if (dataLink == undefined && dataLink == null && (!isNaN(Number(searchTerm.split("-")[0])) || searchTerm.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase())) || searchTerm.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {
        let href = xref.getAttribute('href');
        let UrlParts = href.split("/");
        if (!isNaN(Number(searchTerm.split("-")[0]))) {
          if (searchTerm.includes("(")) {
            searchTerm = searchTerm.split("(")[0];
          }
          if (searchTerm.includes("[")) {
            searchTerm = searchTerm.split("[")[0];
          }
          if (searchTerm.includes("to")) {
            searchTerm = searchTerm.split(" to")[0];
          }
          if (searchTerm.includes("through")) {
            searchTerm = searchTerm.split(" through")[0];
          }
        }
        let url = !isNaN(Number(searchTerm.split("-")[0])) ? "/" + UrlParts[1] + "/" + UrlParts[2] + "/" + searchTerm : "/" + UrlParts[1] + "/" + UrlParts[2];
        this.route.navigateByUrl(url);
        var isMasterGlossaryPage = document.getElementsByTagName("app-master-glossary");
        if (isMasterGlossaryPage.length > 0) {
          this.commonDataService.glossaryTermFromContentPageBackButton.next(this.glossaryTitle);
        }
      }
    }
  }

  navPathTreeCall$: Subscription;
  onRightClick(event: any) {
    if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "xref") {
      let ahref = event.srcElement.innerText;
      if (ahref.includes("(")) { ahref = ahref.split("(")[0]; }
      if (ahref.includes("[")) { ahref = ahref.split("[")[0]; }
      if (ahref.includes("to")) { ahref = ahref.split(" to")[0]; }
      if (ahref.includes("through")) { ahref = ahref.split(" through")[0]; }
      if (isNaN(Number(ahref.split("-")[0])) && !ahref.toLocaleLowerCase().includes(("Accounting Standards Update").toLocaleLowerCase()) && !ahref.toLocaleLowerCase().includes(("subsection").toLocaleLowerCase())) {
        return false;
      }
      else if (ahref.includes("-")) {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + ahref);
      }
      else {
        let otherSourceUrlParts = event.target.getAttribute('href').split("/");
        let otherSourceUrlLastPart = event.target.getAttribute('href').includes('#') ? event.target.getAttribute('href').split('#')[1] : otherSourceUrlParts[otherSourceUrlParts.length - 1];
        event.srcElement.setAttribute("href", "/" + otherSourceUrlParts[1] + "/" + otherSourceUrlParts[2] + "/" + otherSourceUrlLastPart);
      }
    }
    else if (event.srcElement.tagName.toLowerCase() == "a" && event.srcElement.className.toLowerCase() == "ditamap") {
      let ahref = event.srcElement.innerText;
      let navPath = ahref.split("-");
      if (navPath.length >= 3) {
        let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
        if (tempData != undefined && tempData != null) {
          let navPathUrl: string = this.getBreadcrumbWithNavPath(navPath[0] + "-" + navPath[1] + "-" + navPath[2]);
          event.srcElement.setAttribute("href", "/" + navPathUrl.split("/")[0] + "/" + navPathUrl.split("/")[1] + "/" + ahref);
        }
        else {
          this.navPathTreeCall$ = this.graphQlService.getNavPathTree(navPath[0] + "-" + navPath[1] + "-" + navPath[2]).subscribe(data => { event.srcElement.setAttribute("href", "/" + data[0].itemLink.split("/")[0] + "/" + data[0].itemLink.split("/")[1] + "/" + ahref); });
        }
      }
      else {
        event.srcElement.setAttribute("href", "/" + ahref + "/tableOfContent");
      }
    }
  }

  getBreadcrumbWithNavPath(breadcerumbUrl) {
    let navPathUrl = "";
    for (let i = 0; i < 9; i++) {
      let tempData = JSON.parse(localStorage.getItem("leftNavigationMenu"));
      if (tempData[i].itemData != null) {
        for (let j = 0; j < tempData[i].itemData.length; j++) {
          if (tempData[i].itemData[j]?.navPath?.startsWith(breadcerumbUrl)) {
            navPathUrl = tempData[i].itemData[j]?.itemLink;
            return navPathUrl;
          } else {
            if (tempData[i].itemData[j].itemData != null) {
              for (let k = 0; k < tempData[i].itemData[j].itemData.length; k++) {
                if (tempData[i].itemData[j].itemData[k]?.navPath?.startsWith(breadcerumbUrl)) {
                  navPathUrl = tempData[i].itemData[j].itemData[k]?.itemLink;
                  return navPathUrl;
                } else {
                  if (tempData[i].itemData[j].itemData[k].itemData != null) {
                    for (let l = 0; l < tempData[i].itemData[j].itemData[k].itemData.length; l++) {
                      if (tempData[i].itemData[j].itemData[k].itemData[l]?.navPath?.startsWith(breadcerumbUrl)) {
                        navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l]?.itemLink;
                        return navPathUrl;
                      }
                      else {
                        if (tempData[i].itemData[j].itemData[k].itemData[l].itemData != null) {
                          for (let m = 0; m < tempData[i].itemData[j].itemData[k].itemData[l].itemData.length; m++) {
                            if (tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.navPath?.startsWith(breadcerumbUrl)) {
                              navPathUrl = tempData[i].itemData[j].itemData[k].itemData[l].itemData[m]?.itemLink;
                              return navPathUrl;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return "";
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.glossaryParentGuid.next([]);
  }
}
